import { Outlet } from 'react-router-dom';
import '../styles/gameShell.css';

/**
 * Full-screen frame for the mini-games (arena, brawler, match-3, solitaire, durak).
 *
 * `.app-shell` already clears the notch (--tg-safe-top); the games have no balance bar / menu,
 * so this frame adds Telegram's own floating controls ("Close", "⋯") on top —
 * --tg-content-safe-top, the same inset the other screens use for their headers.
 */
export default function GameShell() {
  return (
    <div className="game-shell">
      <Outlet />
    </div>
  );
}
